import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  getStoreProductPriceDisplay,
  isStoreProductOutOfStock,
} from "../../../utils/storeUtils";
import { StorePriceDisplay } from "./StorePriceDisplay";
import "./StoreProductPriceBlock.css";

/**
 * Product list / detail price: optional strikethrough list price, prominent sale price.
 * Uses API `original_price`, `final_price`, `discount_percentage` when present.
 * Out-of-stock products render no price.
 */
export function StoreProductPriceBlock({
  product,
  className = "",
  size = "default",
  /** When false, hide the “-X%” chip (e.g. product card uses a corner badge on the image). */
  showDiscountPercent = true,
}) {
  const { t } = useTranslation("global");
  const outOfStock = isStoreProductOutOfStock(product);
  const { hasDiscount, originalPrice, finalPrice, discountPercent } = useMemo(
    () => getStoreProductPriceDisplay(product),
    [product]
  );
  const sizeClass = size === "large" ? " store-product-price-block--lg" : "";

  if (outOfStock) {
    return null;
  }

  return (
    <span
      className={`store-product-price-block${sizeClass} ${className}`.trim()}
    >
      {hasDiscount ? (
        <>
          <span className="store-product-price-block__was" aria-hidden="true">
            <StorePriceDisplay amount={originalPrice} />
          </span>
          <span className="store-product-price-block__now">
            <StorePriceDisplay amount={finalPrice} />
          </span>
          {showDiscountPercent ? (
            <span className="store-product-price-block__pct">
              {t("store.discountPercentBadge", {
                percent: discountPercent,
                defaultValue: "-{{percent}}%",
              })}
            </span>
          ) : null}
        </>
      ) : (
        <span className="store-product-price-block__now">
          <StorePriceDisplay amount={finalPrice} />
        </span>
      )}
    </span>
  );
}
